export class CentroCustoFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getCustos(filter) {
    return this.instance.get('/v1/cat-cc', {
      params: filter || null,
    });
  }

  getCusto(id) {
    return this.instance.get(`/v1/cat-cc/${id}`);
  }

  addCusto(data) {
    return this.instance.post('/v1/cat-cc', data);
  }

  editCusto(id, data) {
    return this.instance.put(`/v1/cat-cc/${id}`, data);
  }

  deleteCusto(id) {
    return this.instance.delete(`/v1/cat-cc/${id}`);
  }

  arquivarCustos(ids) {
    return this.instance.post('/v1/cat-cc/arquivados', { catCc: ids });
  }

  desarquivarCustos(ids) {
    return this.instance.post('/v1/cat-cc/desarquivados', { catCc: ids });
  }
}

export default (...params) => new CentroCustoFactory(...params);
